import { render, staticRenderFns } from "./VFilter.vue?vue&type=template&id=6b741a9d&scoped=true&"
import script from "./VFilter.vue?vue&type=script&lang=js&"
export * from "./VFilter.vue?vue&type=script&lang=js&"
import style0 from "./VFilter.vue?vue&type=style&index=0&id=6b741a9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b741a9d",
  null
  
)

export default component.exports